import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-header-nav',
  templateUrl: './header-nav.component.html',
  styleUrls: ['./header-nav.component.scss'],
})
export class HeaderNavComponent {
  @Input() activeWindow = 1;
  @Input() disableBackBtn = false;
  @Input() buttonText? : string;
  @Output('back') back: EventEmitter<void> = new EventEmitter();
  @Output('home') home: EventEmitter<void> = new EventEmitter();
  iframeOrigin=sessionStorage.getItem('IframOrigin');

  goBack() {
    if (this.activeWindow > 1 || !this.disableBackBtn) this.back.emit();
  }

  goHome() {
    this.home.emit();
  }
}
